<template>
    <div>
        <h1 style="font-size: 24px; color: black;">帖子监管</h1>
        <el-card  class="margin-bottom-10"  shadow="never" >
            <el-row  type="flex"  align="middle" :gutter="20" >
                <el-col :span="6" class="justyfy-content-space-between">
                        <span > 日期：</span>
                        <el-date-picker
                            v-model="queryData.timeDate"
                            type="daterange"
                            :clearable="false"
                            range-separator="至"
                            start-placeholder="开始日期"
                            end-placeholder="结束日期"
                            format="yyyy-MM-dd"
                            value-format="timestamp">
                        </el-date-picker>
                </el-col>
                <el-col :span="5" class="justyfy-content-space-between">
                        <span> 关联游戏: </span>
                        <el-select v-model="queryData.gameId"   clearable filterable placeholder="请选择/输入">
                            <el-option
                                v-for="item in gameSelectorList"
                                :key="item.id"
                                :label="item.name"
                                :value="item.id">
                            </el-option>
                        </el-select>
                </el-col>
                <el-col :span="5" class="justyfy-content-space-between">
                        <span >话题:</span>
                        <el-select v-model="queryData.topicName"  clearable  filterable placeholder="请选择/输入">
                            <el-option
                                v-for="item in topics"
                                :key="item.id"
                                :label="item.text"
                                :value="item.text">
                            </el-option>
                        </el-select>
                </el-col>
                <el-col :span="4" class="justyfy-content-space-between">
                        <span >关键字:</span>
                        <el-input v-model="queryData.text" style="width: 200px" clearable></el-input>
                </el-col>
            </el-row>
            <el-row  type="flex"  align="middle" :gutter="20" >
                <el-col :span="5"  class="justyfy-content-space-between">
                        <span >是否有图片:</span>
                        <el-select v-model="queryData.isPic"  clearable  filterable placeholder="请选择/输入">
                            <el-option
                                v-for="item in BooleanOptions"
                                :key="item.label"
                                :label="item.label"
                                :value="item.value">
                            </el-option>
                        </el-select>
                </el-col>
                <el-col :span="5" class="justyfy-content-space-between">
                        <span >是否有视频:</span>
                        <el-select v-model="queryData.isVideo"  clearable  filterable placeholder="请选择/输入">
                            <el-option
                                v-for="item in BooleanOptions"
                                :key="item.label"
                                :label="item.label"
                                :value="item.value">
                            </el-option>
                        </el-select>
                </el-col>
                <el-col :span="5" class="justyfy-content-space-between">
                    <span >动态类型:</span>
                        <el-select v-model="queryData.level"  placeholder="请选择/输入">
                            <el-option
                                v-for="item in PostTypeOptions"
                                :key="item.label"
                                :label="item.label"
                                :value="item.value">
                            </el-option>
                        </el-select>
                </el-col>
                <el-col :span="4"   class="justyfy-content-space-between">
                    <span >发帖人id:</span>
                    <el-input v-model="queryData.did" style="width: 200px" @clear="clearDid" clearable></el-input>
                </el-col>
                <el-col :span="4" class="justyfy-content-space-between">
                    <span >评论人id:</span>
                    <el-input v-model="queryData.replyDid" style="width: 200px" @clear="clearReplyDid" clearable></el-input>
                </el-col>
            </el-row>
            <el-row  type="flex"  align="middle" :gutter="20" >
                
            </el-row>
            <el-row>
                <el-col :span="4" >
                    <el-button class="sub-sub" type="primary"  @click="searchPosts">查询</el-button>  
                </el-col>
            </el-row>
        </el-card>
        <div>
            <el-table
                    border
                    :fit="true"
                    :row-class-name="tableRowClass"
                    @sort-change='sortChange'
                    :data="posts">
                <el-table-column prop="createDt" :formatter="formatDate" label="创建时间"> </el-table-column>  
                <el-table-column prop="id" label="帖子id"></el-table-column>
                <el-table-column prop="text"  width="200px" label="帖子内容" :show-overflow-tooltip="true"></el-table-column>
                <el-table-column label="图片" width="200px">
                    <template slot-scope="scope">
                        <span v-for="(item,index) in scope.row.formatImages" :key="index">
                            <el-popover placement="left" trigger="click" width="300">
                                <img :src="item.url" width="100%" />
                                <img
                                    slot="reference"
                                    :src="item.url"
                                    :alt="item.name"
                                    style="max-height: 70px;max-width: 70px; padding: 5px"
                                />
                            </el-popover>
                        </span>
                    </template>
                </el-table-column>
                <el-table-column label="视频" width="150px">
                    <template slot-scope="scope">
                        <template v-if="scope.row.videos">
                            <video :src="VUE_APP_CDN_URL+scope.row.videos" class="avatar1" controls="controls"/>
                        </template>
                    </template>
                </el-table-column>
                <el-table-column prop="topicName" label="话题"></el-table-column>
                <el-table-column prop="gameId" :formatter="formatGameId" label="关联游戏"> </el-table-column>
                <el-table-column prop="officialNickName" label="发布账号"></el-table-column> 
                <el-table-column prop="up" sortable="custom" label="点赞数" :formatter="formatterCount"></el-table-column> 
                <el-table-column prop="discuss" sortable="custom" label="评论数" :formatter="formatterCount"></el-table-column> 
                <el-table-column prop="share" sortable="custom" label="分享数" :formatter="formatterCount"></el-table-column> 
                <el-table-column   label="禁言数" >
                    <template slot-scope="scope">
                            <el-popover
                            placement="left"
                            width="400"
                            trigger="click">
                            <el-table :data="bannedRecords" >
                                <el-table-column width="160" prop="createDt" :formatter="formatDate" label="日期"></el-table-column>
                                <el-table-column width="100" property="type" :formatter="formatBannedType" label="禁言类型"></el-table-column>
                                <el-table-column width="100" property="second" :formatter="formatBannedTime" label="禁言时长"></el-table-column>
                            </el-table>
                            <el-button slot="reference" @click="getResorseBanned(scope.row)">{{scope.row.shutUpTime}}</el-button>
                            </el-popover>
                    </template>
                </el-table-column> 
                <el-table-column prop="did"   label="发帖人id"  ></el-table-column> 
                <el-table-column prop="replyDid"   label="评论人id"  ></el-table-column> 
                <el-table-column label="操作" align="center" width="150px">
                    <template slot-scope="scope">
                        <div style="text-align:center"><el-button size="mini" type="primary" @click="getComments(scope.row)">查看评论</el-button></div>
                        <div style="margin:10px;text-align:center"><el-button size="mini" type="warning"   @click="handleBanned(scope.row)">禁言</el-button></div>
                        <div style="text-align:center"><el-button size="mini" type="danger" :disabled="scope.row.isDelete==true"  @click="handleDelete(scope.row)">删除</el-button></div>
                    </template>
                </el-table-column>
            </el-table>
        </div>
        <!-- 外层设置 分页 -->
        <div>
            <el-pagination
                @size-change="handleTotalSizeChange"
                @current-change="handleTotalCurrentChange"
                :current-page="queryData.page"
                :page-sizes="[20,50,70,100]"
                :page-size="queryData.size"
                layout="total, sizes, prev, pager, next"
                :total="totalSize">
            </el-pagination>
        </div>
        <!-- 禁言弹窗设置 -->
        <div>
            <el-dialog title="禁言设置"
                       center
                       :visible.sync="bannedVisible"
                       @open="plateInfo"   
                       :destroy-on-close="true"
                       width="600px"> 
                            <div style="text-align: center;">
                                <span >禁言类型:&nbsp;</span>
                                <el-select v-model="bannedLabel"  @change="bannedChange"  placeholder="请选择">
                                    <el-option
                                        v-for="item in bannedList"
                                        :key="item.id"
                                        :label="item.name"
                                        :value="item.id">
                                    </el-option>
                                </el-select> 
                            </div>
                            <br>
                            <div style="text-align: center;">
                                <el-button type="primary" @click="confirmBannedDialog">确 定</el-button>
                                <el-button type="info" @click="cancelBannedDialog">取 消</el-button>
                            </div>
            </el-dialog>

        </div>
        <div>
            <el-dialog title="详情"
                       center
                       :visible.sync="commentsDialogVisible"
                       @open="plateInfo"
                       @close="commentsDialogVisible=false"
                       :close-on-click-modal="true"
                       :show-close="true"
                       :destroy-on-close="true"
                       width="1000px">
                <h3>游戏名称:</h3> 
                            <el-select v-model="rule.gameId" disabled   placeholder="无">
                                <el-option
                                    v-for="item in gameSelectorList"
                                    :key="item.id"
                                    :label="item.name"
                                    :value="item.id">
                                </el-option>
                            </el-select> 
                <h3>话题名称:</h3>
                    <el-input
                    type="text"
                    :rows="2"
                    placeholder="无"
                    :disabled="true"
                    v-model="rule.topicName">
                    </el-input>
                <h3>文本内容:</h3>
                    <el-input
                    type="textarea"
                    :rows="2"
                    placeholder="无"
                    :disabled="true"
                    v-model="rule.text">
                    </el-input>
                <h3>图片信息:</h3>  
                        <span v-for="(item,index) in rule.formatImages" :key="index">
                            <img
                                    slot="reference"
                                    :src="item.url"
                                    :alt="item.name"
                                    style="max-height: 500px;max-width: 500px; padding: 5px"
                                />
                        </span> 
                <h3>视频信息:</h3>  
                            <template v-if="rule.videos">
                                <video :src="VUE_APP_CDN_URL+rule.videos" class="avatar1" controls="controls"/>
                            </template> 
                <template>
                    <h4>评论详情</h4>
                    <el-table border
                              ref="multipleTable"
                              :data="firstComments"
                              :row-class-name="gameRowTableClass"
                              stripe
                              tooltip-effect="dark"
                              style="width: 100%"
                              lazy
                              row-key="id"
                            :load="loadSecondComments"
                            :tree-props="{hasChildren: 'hasChildren'}"
                              >
                        <el-table-column prop="id" label="帖子id"></el-table-column>
                        <el-table-column  label="头像" >
                            <template slot-scope="scope">
                                <template>
                                    <img :src="VUE_APP_CDN_URL+scope.row.officialHead" width="70px" height="70px" />
                                </template>
                            </template>
                        </el-table-column>
                        <el-table-column prop="officialNickName" label="昵称"></el-table-column>
                        <el-table-column prop="text" width="200px" label="内容" :show-overflow-tooltip="true"></el-table-column>
                        <el-table-column prop="level" label="级别"></el-table-column>
                        <el-table-column  prop="createDt" :formatter="formatDate" label="创建时间"> </el-table-column>
                         <el-table-column prop="up"  label="点赞数" :formatter="formatterCount" > </el-table-column>
                        <el-table-column label="操作" align="center" width="100px">
                            <template slot-scope="scope">
                                <el-button size="mini" type="danger" :disabled="scope.row.isDelete==true"  @click="handleDelete(scope.row)">删除</el-button>
                            </template>
                        </el-table-column>
                    </el-table>
                    <div>
                        <el-pagination
                                @size-change="innerSizeChange"
                                @current-change="innerCurrentChange"
                                :current-page="innerQueryData.page"
                                :page-sizes="[20,50,70,100]"
                                :page-size="innerQueryData.size"
                                layout="total, sizes, prev, pager, next"
                                :total="innerTotalSize">
                        </el-pagination>
                    </div>
                </template>
            </el-dialog>
        </div>
    </div>
</template>

<script>
    import {
        gameRunningList,
        searchNormalPosts,
        changeOfficialDelete,
        searchFirstPostComments,
        searchSecondPostComments,
        openTopic,
        bannedUser,
        bannedRecord

    } from "@/http/api";
    import utils from '@/utils'
    export default {
        name: "PostAudit",
        data () {
            return {
                headers: {},
                url:'',
                loading: false,
                labelWidth: '200px',
                //bannedTypeList
                bannedList:[
                    {id:1,name:"1小时",type:1,time:3600},
                    {id:2,name:"24小时",type:1,time:86400},
                    {id:3,name:"48小时",type:1,time:172800},
                    {id:4,name:"永久禁言",type:2,time:9999999},
                ],
                //禁言dialog标志位
                bannedVisible:false,
                //下拉框标志位
                bannedLabel:null,
                //禁言提交数据
                bannedUpdateData:{
                    did:null,
                    type:null,
                    second:null
                },
                //禁言数据
                bannedRecords:[],
                //列表数据
                posts: [
                ],
                //外层列表数量
                totalSize:0,
                //内层列表数量
                innerTotalSize:0,
                //一级评论列表数据
                firstComments: [
                ],
                //二级评论列表数据
                secondComments: [
                ],
                //每行数据
                rule:{},
                //外层搜索查询条件
                queryData:{
                    "officialNickName":null,
                    "gameId": null,
                    "topicName":null,
                    "text":null,
                    "page":1,
                    "size":20,
                    "orders":"createDt desc ",
                    "isDelete":false,
                    "startDt":null,
                    "endDt":null,
                    "timeDate":[],
                    "isPic":null,
                    "isVideo":null,
                    "level":1,
                    "did":null,
                    "replyDid":null
                },
                //外层分页
                pagination:{
                    size:10,
                    pageNumber:1,
                },
                //内层查询条件 page size
                innerQueryData:{
                    "page":1,
                    "size":20
                },
                games:[],
                cateList:[],
                //游戏选品中游戏列表下拉框数据 固定的
                gameSelectorList: [], 
                //内部弹窗可见
                commentsDialogVisible:false,
                //全部topic信息
                topics:[],
                //查询日期区间
                searchDateRange:[],
                pickerMinDate:'',
                pickerOptions: {
                    onPick: (time) => {
                        // this.pickerMinDate = time.minDate;
                        if(time.minDate && !time.maxDate){
                            this.pickerMinDate=time.minDate;  //将第一次选中值保存
                        }
                        if(time.maxDate){
                            this.pickerMinDate=null;
                        }
                    },
                    disabledDate:(time)=> {
                        if (this.pickerMinDate) {
                            const day1 =  7 * 24 * 3600 * 1000;
                            let maxTime = this.pickerMinDate.getTime() + day1;
                            let minTime = this.pickerMinDate.getTime() - day1;
                            return time.getTime() > maxTime || time.getTime() < minTime || time.getTime() > Date.now()+24 * 3600 * 1000
                        }else{
                            return time.getTime() > Date.now()+24 * 3600 * 1000
                        }
                    }
                },
                VUE_APP_BASE_URL:'',
                VUE_APP_CDN_URL:'',
                BooleanOptions:[
                    {value:true,label:"是"},
                    {value:false,label:"否"}
                ],
                PostTypeOptions:[
                    {value:1,label:"帖子"},
                    {value:2,label:"一级回复"},
                    {value:3,label:"二级回复"}
                ]
            }
        },
        created () {
            this.headers ={Authorization : this.$store.state.user.token};
            gameRunningList().then(resp=>{
                 this.gameSelectorList=resp.data.info;
             });
             this.searchPosts();
             openTopic().then(resp=>{
                 this.topics=resp.data.info;
             })
        },
        methods:{
            //格式化游戏id
            formatGameId: function(row, column,cellValue) {
                var temp="无"
                    this.gameSelectorList.forEach( item => {
                        if(item.id===cellValue){ 
                             temp=item.name;
                             
                        }
                    })
                    return temp
            },
            //禁言类型格式化
            formatBannedType: function(row, column,cellValue) {
                var temp="其他"
                        if(cellValue==1){ 
                             temp="按秒禁言";
                        }else if(cellValue==2){
                            temp="永久禁言"
                        }
                    return temp
            },
            //禁言类型格式化
            formatBannedTime: function(row, column,cellValue) {
                var temp=""
                    this.bannedList.forEach( item => {
                        if(item.time==cellValue){ 
                             temp=item.name;
                        }else{
                            temp=cellValue+"s"
                        }
                    })
                    return temp
            },
            //带百分数的格式化
            formatterPercent: function (row, column, cellValue){
                if(cellValue===null){
                    return "0%";
                }else{
                    return (cellValue*100).toFixed(2)+"%";
                }
                
            },
            //默认数字的格式化 赋值默认值为0
            formatterCount: function (row, column, cellValue){
                if(cellValue===null){
                    return 0;
                }else{
                    return cellValue;
                }
                
            },
            //格式化日期
            formatDate: function(row, column) {
                return utils.DateUtil.formatDate(row[column.property], "YYYY-MM-DD HH:mm:ss")
            },
            clearDid() {
                this.queryData.did=null;
            },
            clearReplyDid(){
                this.queryData.replyDid=null;
            },
            //根据游戏id获取游戏名称
            gameRowTableClass({row,rowIndex}){
                row.index=rowIndex
            },
            getRowKeys(row){
                return row.id
            },
            // 总条数修改
            handleTotalSizeChange(newSize) {
                this.queryData.size = newSize;
                this.searchPosts();
            },
            //总页数跳转
            handleTotalCurrentChange(newPage) {
                this.queryData.page = newPage;
                this.searchPosts();
            },
            //修改排序顺序
            sortChange(param){
                // console.log(param);
                if(param.prop == null ){
                    return;
                }else {
                    if( param.order == null){
                        return;
                    }else {
                        // console.log(param.order);
                        this.queryData.orders=param.prop+" "+param.order+",createDt desc ";
                        // console.log(this.queryData.orders)
                    }
                }
                this.searchPosts();
            },
            // ========================================禁言相关
            //点击禁言按钮
            handleBanned(row){
                this.bannedVisible=true;
                this.rule=row;
                this.bannedUpdateData.type=null;
                this.bannedUpdateData.did=null;
                this.bannedUpdateData.time=null;
                this.bannedLabel=null;
            },
            //禁言下拉框选择
            bannedChange(id){
                let dir = this.bannedList.find((item) => item.id == id);
                //重复赋值selecter绑定参数 否则会下拉框提示异常
                // this.bannedLabel=dir.name;
                this.bannedUpdateData.type=dir.type;
                this.bannedUpdateData.did=this.rule.did;
                this.bannedUpdateData.time=dir.time;
            },
            //取消窗口  进行初始化
            cancelBannedDialog () {
                this.bannedVisible=false;
                this.bannedUpdateData.type=null;
                this.bannedUpdateData.did=null;
                this.bannedUpdateData.time=null;
                this.bannedLabel=null;
            },
            // 确认禁言信息
            confirmBannedDialog: function(){
                // console.log(this.matchEditForm)
                    if(this.bannedUpdateData.did==null || this.bannedUpdateData.type==null || this.bannedUpdateData.time==null ){
                            this.$message({
                                message: "参数异常",
                                type: 'error'
                            });
                        return ;
                    }
                    bannedUser(this.bannedUpdateData.did,this.bannedUpdateData.type,this.bannedUpdateData.time).then(resp=>{
                        if (resp.data.status===0){
                          this.$message({
                                message: "操作成功",
                                type: 'success'
                            });
                        this.searchPosts();
                        }
                    })
                    this.cancelBannedDialog();
            },
            //获取禁言记录
            getResorseBanned(row){
                // console.log(row);
                bannedRecord(row.did).then(resp=>{
                    // console.log(resp.data.info)
                    this.bannedRecords=resp.data.info;
                })
            },
            //-------------------------------------------相关方法
            //查询官方贴方法
            searchPosts:function(){
                //判断是否选择了日期
                if(this.queryData.timeDate.length>0){
                    var tempDate=this.queryData.timeDate;
                    this.queryData.startDt=tempDate[0];
                    this.queryData.endDt=tempDate[1];
                }
                // console.log(this.queryData)
                searchNormalPosts(this.queryData).then(resp=>{
                    //设置images格式
                    let listBefore=resp.data.info.list;
                    listBefore.forEach(item=> {
                        //图片处理
                        // console.log(item.images);
                        item.formatImages=[];
                        if(item.images!=null){
                            // let tempArrayImages=JSON.parse(item.images);
                            //使用逗号分隔字符串截取图片信息
                            var tempArrayImages= new Array(); //定义一数组
                            tempArrayImages=item.images.split("，"); //字符分割 这里使用的是中文逗号
                            // console.log(tempArrayImages)
                            if(tempArrayImages.length>0){
                                tempArrayImages.forEach(imagesUrl=>{
                                    var temp={name:null,url:null,postUrl:null};
                                    var url=imagesUrl;
                                    var array=url.split('/');
                                    temp.name=array[array.length-1];
                                    temp.url=process.env.VUE_APP_CDN_URL +url;
                                    temp.postUrl=url;
                                    item.formatImages.push(temp);
                                    // console.log(temp)
                                })
                            }
                        }
                        
                    })
                    // console.log(listBefore)
                    this.posts = listBefore;
                    this.totalSize=resp.data.info.totalElements;
                })
            },
            // 修改是否可见开关开启关闭 方法
            handleDelete: function (row) {
                this.$confirm('确认是否删除?', '警告', {
                    cancelButtonClass: 'btn-custom-cancel',
                    confirmButtonText: '确认',
                    cancelButtonText: '取消',
                    type: 'warning'
                }).then(() => {
                    row.isDelete=true;
                    changeOfficialDelete(row.did,row.id,row.isDelete).then(resp=>{
                        if (resp.data.status==0){
                            this.$message({
                                message: "操作成功",
                                type: 'success'
                            });
                        }else{
                            //恢复开关键
                            row.isDelete=false;
                            this.$message({
                                message: "操作失败",
                                type: 'error'
                            });
                        }
                    });
                }).catch(() => {
                })
            },
            tableRowClass: function(row){
                if(row.rowIndex%2===1){
                    return 'row_odd_class'
                }
                return ''
            },
            //查询评论部分
            getComments(row){
                this.rule=row;
                this.gameSelectorTemp();
                //展示dialog
                this.commentsDialogVisible=true;
            },
            //待处理
            gameSelectorTemp() {
                // console.log(this.innerQueryData)
                searchFirstPostComments(this.rule.did,this.rule.id,this.innerQueryData.page,this.innerQueryData.size).then(resp=>{
                    //处理插入子节点标志位
                    this.innerTotalSize=resp.data.info.totalElements;
                    let arrays=resp.data.info.list;
                    //全部设置有子节点 树形结构用
                    arrays.forEach(item => {item.hasChildren=true})
                    this.firstComments=arrays; 
                });
            },
            //加载二级评论方法
            loadSecondComments(tree, treeNode, resolve){
                // console.log(tree)
                searchSecondPostComments(tree.did,tree.id).then(resp=>{
                    // console.log(resp.data.info);
                    resolve(resp.data.info)
                })
            }, 
            
            innerSizeChange(newSize){
                this.innerQueryData.size=newSize;
                this.gameSelectorTemp()
            },
            innerCurrentChange(newPage){
                this.innerQueryData.page=newPage;
                this.gameSelectorTemp()
            },
            plateInfo(){
                return this.rule;
            },
        },

        mounted () {  
            //这里获取video地址
            this.VUE_APP_CDN_URL = process.env.VUE_APP_CDN_URL;
            this.VUE_APP_BASE_URL = process.env.VUE_APP_BASE_URL;
        }
    }
</script>
<style scoped>

</style>
